/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Availability } from './availability';
import { Vacation } from './vacation';


export interface UserProfile { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    userId: string;
    displayAgency?: string;
    position?: string;
    location?: string;
    language?: string;
    phone?: string;
    phoneMobile?: string;
    availabilities?: Availability;
    vacations?: Array<Vacation>;
}

